import { z } from "zod";

export const ClientSynthesisPeriodSchema = z.union([
  z.literal(3),
  z.literal(6),
  z.literal(12),
  z.literal(0),
]);

export type ClientSynthesisPeriod = z.infer<typeof ClientSynthesisPeriodSchema>;

export const ClientSynthesisRequestSchema = z
  .object({
    includeNotes: z.boolean().optional().default(true),
    includeReports: z.boolean().optional().default(true),
    includeObjectives: z.boolean().optional().default(true),
    /** 0 = toute la période, sinon nombre de mois glissants. */
    periodMonths: ClientSynthesisPeriodSchema.optional().default(3),
  })
  .refine(
    (v) => v.includeNotes || v.includeReports || v.includeObjectives,
    { message: "Sélectionnez au moins une source" },
  );

export type ClientSynthesisRequestDto = z.infer<
  typeof ClientSynthesisRequestSchema
>;

export const ClientSynthesisResponseSchema = z.object({
  markdown: z.string(),
  sourcesUsed: z.object({
    notes: z.number().int(),
    reports: z.number().int(),
    objectives: z.number().int(),
  }),
  truncated: z.boolean(),
});

export type ClientSynthesisResponseDto = z.infer<
  typeof ClientSynthesisResponseSchema
>;
